import { useContext } from 'react';
import { FapAppContext } from '../../../context/fap-app.context';
import bem from '../../../utils/bem';
import ContractorCard from '../../../Components/Molecules/Cards/ContractorCard';
import useWindowWidth from '../../../hooks/useWindowWidth';

const ThankYouPage = () => {
  const { contractorsTray } = useContext(FapAppContext);
  const componentClassName = 'fap-thank-you-page';
  if (!contractorsTray || !contractorsTray.length) {
    return null;
  }
  const { breakpoint } = useWindowWidth();
  const gridTemplateColumns = contractorsTray.map(() => `1fr`).join(' ');
  return (
    <div className="container">
      <div className={bem(componentClassName)}>
        <h5 className={bem('subtitle', [], componentClassName, ['h', 'h5'])}>
          {Drupal.t(`Learn more about the contractors you've selected`)}
        </h5>
        <div
          className={bem('contractors', [], componentClassName, [])}
          style={{
            gridTemplateColumns: !breakpoint.isMobile
              ? gridTemplateColumns
              : '1fr',
          }}
        >
          {contractorsTray.map((contractor) => (
            <ContractorCard
              key={contractor.id}
              contractorData={contractor}
              isSmall
              showDefaultImage
              showProfileBtn
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
